import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { trackingURL } from '@xingternal/xing-tracking';
import { trackings } from '../../../tracking';
import { Item } from '../Item';
import { Section } from './components';
const translations = {
    MemberPredictiveSearchItem: {
        text: 'VERTICAL_NAVIGATION_HEADER_SEARCH_MEMBERS',
        section: 'members',
    },
    JobPredictiveSearchItem: {
        text: 'VERTICAL_NAVIGATION_HEADER_SEARCH_JOBS',
        section: 'jobs',
    },
    EventPredictiveSearchItem: {
        text: 'VERTICAL_NAVIGATION_HEADER_SEARCH_EVENTS',
        section: 'events',
    },
    NewsPredictiveSearchItem: {
        text: 'VERTICAL_NAVIGATION_HEADER_SEARCH_NEWS',
        section: 'news',
    },
    CompanyPredictiveSearchItem: {
        text: 'VERTICAL_NAVIGATION_HEADER_SEARCH_COMPANIES_PROFILE',
        section: 'companies',
    },
    CommunityPredictiveSearchItem: {
        text: 'VERTICAL_NAVIGATION_HEADER_SEARCH_COMMUNITIES',
        section: 'communities',
    },
};
function IncrementalSearchSection({ baseI, highlightedIndex, intl: { formatMessage }, section: { items }, getItemProps, userId, searchType, }) {
    return (React.createElement(Section, { type: "incremental-search" }, items.map(({ __typename, trackingToken, payload: { url, ...payload } }, i) => {
        const position = baseI + i;
        const isHighlighted = position === highlightedIndex;
        if (__typename === 'MemberPredictiveSearchItem') {
            return (React.createElement(Item, { getItemProps: getItemProps, key: trackingToken, data: {
                    ...payload,
                    url: trackingURL(url, 'result')(trackings),
                    trackingToken,
                    position,
                    userId,
                }, searchType: searchType, isHighlighted: isHighlighted }));
        }
        return (React.createElement(Item, { getItemProps: getItemProps, key: trackingToken, data: {
                ...payload,
                url: trackingURL(url, 'result')(trackings),
                subtitle: formatMessage({
                    id: translations[__typename].text,
                }),
                trackingToken,
                position,
                userId,
            }, searchType: searchType, isHighlighted: isHighlighted }));
    })));
}
IncrementalSearchSection.propTypes = {
    baseI: PropTypes.number.isRequired,
    highlightedIndex: PropTypes.number,
    intl: PropTypes.object.isRequired,
    getItemProps: PropTypes.func.isRequired,
    userId: PropTypes.string.isRequired,
    searchType: PropTypes.string.isRequired,
    section: PropTypes.shape({
        items: PropTypes.arrayOf(PropTypes.shape({
            payload: PropTypes.shape({
                url: PropTypes.string.isRequired,
            }).isRequired,
            trackingToken: PropTypes.string.isRequired,
            __typename: PropTypes.string.isRequired,
        })).isRequired,
    }).isRequired,
};
export default injectIntl(IncrementalSearchSection);
//# sourceMappingURL=IncrementalSearch.js.map